import { DataGridPro, type GridColDef, type GridRowsProp, type GridApiPro } from '@mui/x-data-grid-pro'
import { sortDates, formatDateDisplay } from '@/lib/metrics'

interface TransposedDataGridProps {
  apiRef?: React.MutableRefObject<GridApiPro>
  rows: GridRowsProp
  firstColumn: GridColDef
  lastColumn?: GridColDef
  dates: string[]
}

export function TransposedDataGrid({
  apiRef,
  rows,
  firstColumn,
  lastColumn,
  dates,
}: TransposedDataGridProps) {
  const sortedDates = sortDates(dates, 'desc')
  const columns: GridColDef[] = [
    {
      ...firstColumn,
      width: 200,
      hideable: false,
      disableColumnMenu: true,
    },
    ...sortedDates.map((dateStr) => ({
      field: dateStr,
      headerName: formatDateDisplay(dateStr),
      type: 'number' as const,
      width: 90,
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      hideable: false,
      pinnable: false,
    })),
    ...(lastColumn
      ? [
          {
            ...lastColumn,
            width: 150,
            hideable: false,
            disableColumnMenu: true,
          },
        ]
      : []),
  ]

  return (
    <DataGridPro
      apiRef={apiRef}
      rows={rows}
      columns={columns}
      disableRowSelectionOnClick
      hideFooter
      initialState={{
        pinnedColumns: {
          left: [firstColumn.field],
          right: lastColumn ? [lastColumn.field] : undefined,
        },
        density: 'compact',
      }}
      sx={{
        backgroundColor: 'white',
        '& .MuiDataGrid-columnHeader': {
          backgroundColor: '#f3f4f6',
          fontSize: '0.875rem',
          fontWeight: 600,
          padding: '12px 8px',
        },
        '& .MuiDataGrid-cell--pinnedLeft': {
          fontWeight: 'bold',
          backgroundColor: '#e5e7eb',
        },
        '& .MuiDataGrid-cell--pinnedRight': {
          fontWeight: 'bold',
          backgroundColor: '#e5e7eb',
        },
        '& .MuiDataGrid-columnHeader--pinnedLeft': {
          backgroundColor: '#e5e7eb',
        },
        '& .MuiDataGrid-columnHeader--pinnedRight': {
          backgroundColor: '#e5e7eb',
        },
        '& .MuiDataGrid-cell': {
          padding: '12px 8px',
          lineHeight: '1.6',
          fontSize: '0.875rem',
        },
        '& .MuiDataGrid-row': {
          '&:hover': {
            backgroundColor: '#f9fafb',
          },
        },
        '& .MuiDataGrid-virtualScroller': {
          overflowX: 'auto',
          '&::-webkit-scrollbar': {
            height: '8px',
          },
        },
        '& .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
      }}
    />
  )
}
